export const BARS_HEIGHT = '150px';
export const BASIC_GRADIENT_BACKGROUND_HEIGHT = '627px';
export const MAX_WIDTH = '640px';
